<template>
  <div>

    <div class="d-inline">
      <h2 class="d-inline shmu-h2-blue mr-3">A-LAEF - ALARO - Limited Area Ensemble Forecasting</h2>
      <b-button class="d-inline mb-1 small" size="sm" variant="primary" @click="loadData"><b-icon-arrow-clockwise></b-icon-arrow-clockwise> {{ $t('reload') }}</b-button>
      <div class="float-right d-none d-lg-inline-block mb-1 ">
        <a href="/">
          <img :src="logo_src" class="img-fluid" style="max-height: 35px">
        </a>
        <a role="button" @click="switchLang" class="ml-2"><img :src="lang_src" class="wh_flag" /></a>
      </div>
      <div class="clearfix"></div>
    </div>

    <b-overlay :show="busy" rounded="sm" variant="light" opacity="0.6" @hidden="onHidden">

      <template v-slot:overlay>
        <div v-if="isImagesLoading" class="text-center p-4 bg-primary text-light rounded">
          <b-icon-cloud-download font-scale="3"></b-icon-cloud-download>
          <div class="mb-3">{{ $t('nacitavam_obrazky') }}...</div>
          <b-progress
            min="1"
            :max="counter_max"
            :value="counter_current"
            variant="success"
            height="15px"
            :striped="true"
            :animated="true"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
      </template>

      <b-card bg-variant="light" class="p-1 p-md-2 alaef-card" no-body>
        <b-alert variant="danger" show class="mb-0" v-if="isError && errorMsg!==null">
          <h4 class="alert-heading">{{ $t('nastala_chyba') }}</h4>
          <p>{{ errorMsg }}</p>
        </b-alert>
        <b-form inline v-if="dataLoaded" class="row mx-0" >
          <b-form-group id="group-alaef-produkty" :label="$t('alaef.produkt')+`:`" label-for="alaef-produkty" class="mr-2 mt-1 col-md-4 col-lg-2 col-12">
            <b-form-select
              v-model="alaef_produkt_selected"
              class="ml-2"
              size="md"
              id="alaef-produkty"
              :options="alaef_produkty"
            ></b-form-select>
          </b-form-group>

          <b-form-group id="group-alaef-runtime" :label="$t('alaef.beh_modelu')+`:`" label-for="alaef-runtime"  class="mr-2 mt-1 col-md-4 col-lg-2  col-12">
            <b-form-select
              class="ml-2"
              size="md"
              id="alaef-runtime"
              v-model="alaef_runtime_selected"
              :options="alaef_runtimes"
            ></b-form-select>
          </b-form-group>

          <b-form-group id="group-alaef-range" :label="$t('alaef.dlzka_predpovede')+`:`" label-for="alaef-range"  class="mr-2 mt-1 col-md-4 col-lg-2 col-12">

            <div class="text-nowrap">
            <b-form-select
              class="ml-2 d-inline-flex"
              size="md"
              id="alaef-range"
              v-model="alaef_range_selected"
              :options="alaef_ranges"
            ></b-form-select>

            <b-button-group class="d-inline-flex ml-2">
              <b-button variant="primary" size="md" :disabled="btnPrevDisabled" @click="setPrevRange"><b-icon-arrow-left-short></b-icon-arrow-left-short></b-button>
              <b-button variant="primary" size="md" :disabled="btnNextDisabled" @click="setNextRange"><b-icon-arrow-right-short></b-icon-arrow-right-short></b-button>
            </b-button-group>
            </div>

          </b-form-group>

          <b-col class="col-12 col-md-4 col-lg-2 mt-1 px-1" >
              <b-form-input style="height: 31px" id="range-step" v-model="range_model" type="range" :min="step_min" :max="step_max" :step="step_step"></b-form-input>
          </b-col>

          <b-form-group class="d-md-inline-flex col-md-4 col-12 col-lg-3" style="height: 33px" >
            <b-form-checkbox class="d-inline-flex" variant="secondary" v-model="showTooltip">Tooltip</b-form-checkbox>

            <a class="small ml-3" target="_blank" :href="$t('alaef.more_information_link')">{{ $t('alaef.more_information') }}</a>

            <b-button class="d-inline-flex ml-3" variant="secondary" v-if="showResetZoom" size="sm" @click="resetZoom()">{{ $t('reset_zoom') }}</b-button>

          </b-form-group>


        </b-form>
      </b-card>
      <b-card class="mt-1 text-center h-100 p-0" no-body v-if="this.alaef_range_selected !== null">
        <pinch-zoom ref="pz" style="position: relative;" limitPan="true" disableZoomControl="disable" limitZoom="5" backgroundColor="rgba(255,255,255,1)">
          <img :src="current_image" crossOrigin="anonymous" ref="imgalaef" class="position-relative img-fluid" @mouseleave="imgMouseLeave" @mousemove="imgMouseMove" @mouseout="imgMouseOut">
          <canvas style="display: none" ref="cs"></canvas>
          <div class="tooltipx" ref="ttip" :style="ttipStyle">{{ ttipVal }}</div>
        </pinch-zoom>
      </b-card>
    </b-overlay>
    <image-preloader
      :srcs="imagesToPreload"
      @loaded-all="imageLoadedAll"
      @loaded="imageLoadedOne"
      @onerror="imagePreloadError"
    />
  </div>
</template>

<script>
  import SHMUconf from '../shmu_conf'
  import Axios from 'axios'
  import imagePreloader from '../components/imagePreloader'
  import PinchZoom from 'vue-pinch-zoom';
  import i18n from '../pages/ALAEF/i18n'
  import _ from 'lodash'


  export default {
    components: {
      'image-preloader': imagePreloader,
      'pinch-zoom': PinchZoom


    },
    data: function () {
      return {
        btnPrevDisabled: true,
        btnNextDisabled: true,
        alaef_data: [],
        dataLoaded: false,

        alaef_produkty: [],
        alaef_produkt_selected: null,

        alaef_runtimes: [],
        alaef_runtime_selected: null,

        alaef_ranges: [],
        alaef_range_selected: null,

        busy: false,
        imagesToPreload: [],
        loaded_images: [],
        current_product: null,
        current_product_meta: {  },
        current_range: null,
        current_files_list: [],
        current_image: SHMUconf.SITE_BASE_URL + 'img/blank1px.gif',
        isImagesLoading: true,
        step_min: 0,
        step_max: 72,
        step_step: 6,
        counter_max: 100,
        counter_current: 1,
        range_model: null,
        isLoading: false,
        pinchZoomScale: 0,
        showResetZoom: false,
        rzInterval: null,
        isError: false,
        errorMsg: null,
        isFromMouting: true,
        customRangeSelected: null,
        customRunSelected: null,
        ttipStyle: {},
        ttipVal: '',
        imgInCanvas: null,
        canvasData: null,
        showTooltip: false,
        is_debug: false

      }
    },
    computed: {
      logo_src: function() {
        let lang = 'sk';
        if (['sk','en'].includes(i18n.locale)>0) {
          lang = i18n.locale;
        }
        //return this.getImgUrl('shmu-logo-' + lang + '.png')
        return SHMUconf.IMG_ASSETS_PATH + 'shmu-logo-' + lang + '.png';
      },
      lang_src: function() {
        let lang = 'sk';
        if (i18n.locale === 'sk') lang = 'en';
        return SHMUconf.IMG_ASSETS_PATH + 'flag_'+lang+'.svg';
      }
    },
    mounted() {
      this.loadData();
      this.rzInterval = setInterval(() => {
        if(this.$refs.pz){
          this.pinchZoomScale = this.$refs.pz.getScale();
        }
      }, 100);

      if (this.$ls.get('alaef_tooltip_state')) this.showTooltip = true;
      else this.showTooltip = false;


    },
    destroy() {
      clearInterval(this.rzInterval);
    },
    updated () {
      if (this.alaef_produkty.length > 0) {
        this.alaef_produkty.forEach(v => {
          v.text = this.$t(v.i18nKey);
        });
      }
    },
    watch: {
      showTooltip() {
        this.$ls.set('alaef_tooltip_state', this.showTooltip, 365 * 24 * 60 * 60 * 1000); // 1 rok
      },
      alaef_data() {
        if (this.alaef_data.products.length > 0) {
          this.alaef_produkty = [];

          // pridaj translations do i18n
          if (this.alaef_data.meta.length >0) {
            let sk = i18n.getLocaleMessage('sk');
            let en = i18n.getLocaleMessage('en');

            this.alaef_data.meta.forEach(v => {
              sk.alaef[v.name] = v.sk;
              en.alaef[v.name] = v.en;
            });
            i18n.setLocaleMessage('sk', sk);
            i18n.setLocaleMessage('en', en);
          }

          this.alaef_data.products.forEach(v => {
            this.alaef_produkty.push({value:v.name, i18nKey:'alaef.'+v.name, text:this.$t('alaef.'+v.name)});
          });

          if (this.alaef_produkty.length > 0) {
            this.alaef_produkt_selected = this.alaef_produkty[0].value;
          }


          this.$nextTick(function() {
            if (this.alaef_runtime_selected !== null && this.alaef_runtimes.length > 0) {
              this.alaef_runtime_selected = this.alaef_runtimes[0].value;

            }

          });
        }
      },
      alaef_produkt_selected(v) {
        if (this.is_debug) console.log('alaef_produkt_selected', v);
        this.selectProdukt(v);
      },
      alaef_runtime_selected(v) {
        if (this.is_debug) console.log('alaef_runtime_selected', v);
        this.selectRuntime(v);
      },
      alaef_range_selected(v) {
        if (this.is_debug) console.log('alaef_range_selected', v);
        this.selectRange(v);
        if (this.range_model != v) {
          this.range_model = v;
        }
      },
      range_model(v) {
        if (this.alaef_range_selected != v) {
          this.alaef_range_selected = parseInt(v);
        }
        //this.selectRange(parseInt(v));
      },
      pinchZoomScale(v) {
        if (v > 1) {
          this.showResetZoom = true;
        } else {
          this.showResetZoom = false;
        }
      }
    },
    methods: {
      loadData() {
        this.busy = true;
        const self = this;
        Axios.get(SHMUconf.API_BASE_URL + 'nwp/getalaefmaps', {
          crossDomain: true,
          cache: false,
        }) .then((response) => {
          if (!response.data.error) {
            self.alaef_data = response.data;
            self.dataLoaded = true;
            this.isError = false;
            this.errorMsg = null;

          } else {
            this.makeToast(this.$t('nastala_chyba'), this.$t('alaef.alaef_error_loading'), 'danger');
            this.isError = true;
            this.errorMsg = this.$t('alaef.alaef_error_loading');
          }
          this.busy = false;
          this.isImagesLoading = false;
        }).catch((error) => {
          this.makeToast(this.$t('nastala_chyba'), this.$t('server_comm_error'), 'danger');
          this.busy = false;
          this.isImagesLoading = false;
          this.isError = true;
          this.errorMsg = this.$t('server_comm_error');
        });

      },
      selectProdukt(v) {
        if (v !== null) {
          this.btnPrevDisabled = true;
          this.btnNextDisabled = true;
          this.current_product = null;
          let selected_produkt = this.alaef_data.products.find(item => item.name === v);

          this.current_product_meta = this.alaef_data.meta.find(item => item.name === v);

          let runtimes_avail = [];
          if (selected_produkt) {
            this.current_product = selected_produkt;
            this.customRunSelected = this.alaef_runtime_selected;
            this.customRangeSelected = this.alaef_range_selected;
            // this.alaef_runtime_selected = null;
            // this.alaef_range_selected = null;
            this.alaef_runtimes = [];
            this.alaef_ranges = [];
            selected_produkt.data.forEach(rt => {
              runtimes_avail.push(rt.runtime);
              this.alaef_runtimes.push({
                value: rt.runtime,
                text: this.$moment.unix(rt.runtime).format('DD.MM.YYYY HH') + 'h UTC'
              });
            });

            if (this.alaef_runtimes.length > 0) {
              this.alaef_runtimes.sort((a, b) => (a.value > b.value) ? -1 : ((b.value > a.value) ? 1 : 0));

              if (this.isFromMouting) {
                // ak som zo startu, nastavim prvy
                this.alaef_runtime_selected = this.alaef_runtimes[0].value; // test, ma tu byt 0
              } else {
                // som zo zmeny, tak nastavim povodny, ak existuje
                let run_to_select = this.alaef_runtimes[0].value;
                if (this.customRunSelected !== null && runtimes_avail.indexOf(this.customRunSelected) !== -1) {
                  run_to_select = this.customRunSelected;
                  if (this.is_debug) console.log('selectProdukt - mam povodny', run_to_select);
                }
                if (this.is_debug) console.log('selectProdukt - run_to_select', run_to_select, this.alaef_runtimes);
                if (this.alaef_runtime_selected === run_to_select) {
                  this.selectRuntime(run_to_select)
                } else {
                  this.alaef_runtime_selected = run_to_select;
                }
              }
              // this.selectRuntime(this.alaef_runtimes[0].value);
            }
          }
        }
      },
      selectRuntime(v) {
        if (v !== null) {

          if (!this.isFromMouting) {
            this.customRunSelected = v;
          }

          if (this.is_debug) console.log('selectRuntime', v)

          // this.alaef_range_selected = null;
          this.alaef_ranges = [];
          let alaef_ranges_pure = [];
          if (this.current_product) {
            let selected_runtime = this.current_product.data.find(item => item.runtime === v);
            if (selected_runtime) {
              this.imagesToPreload = [];
              selected_runtime.files.forEach(fi => {
                alaef_ranges_pure.push(fi.step);
                this.alaef_ranges.push({
                  value: fi.step,
                  text: fi.step + 'h'
                });

                if (fi.url.charAt(0) === '/') fi.url = fi.url.substr(1);
                this.imagesToPreload.push(SHMUconf.SITE_DATA_URL + fi.url);
              });
              if (this.alaef_ranges.length > 0) {
                this.isImagesLoading = true;
                this.busy = true;
                this.current_files_list = selected_runtime.files;

                this.step_min = this.alaef_ranges[0].value;
                this.step_max = this.alaef_ranges[this.alaef_ranges.length-1].value;
                this.step_step = this.alaef_ranges[1].value - this.alaef_ranges[0].value;


                if (this.isFromMouting) {
                  if (this.is_debug) console.log('from boot:');
                  // zisti hodinu runtime
                  let cur_runtime_h = parseInt(this.$moment(this.alaef_runtime_selected*1000).format('H'));
                  if (this.is_debug) console.log('runtime UTC hour', cur_runtime_h);

                  let cur_hour = parseInt(this.$moment().utc().format('H'));
                  if (this.is_debug) console.log('current UTC hour', cur_hour);
                  // pripocitaj hodinu runtime k cur_hour
                  cur_hour  -= cur_runtime_h;

                  if (this.is_debug) console.log('to select', cur_hour);

                  let closest =  alaef_ranges_pure.filter(function(v){return v > cur_hour})[0];

                  if (this.is_debug) console.log('closest upper found', closest);
                  if (this.alaef_range_selected === closest) {
                    if (this.is_debug) console.log('forced select', closest);
                    this.selectRange(closest);
                  } else {
                    if (this.is_debug) console.log('trigger to select', closest);
                    this.alaef_range_selected = closest;
                  }
                  // this.selectRange(closest);

                  this.isFromMouting = false;
                } else {
                  if (this.is_debug) console.log('from manual select:');
                  let range_to_select = this.alaef_ranges[0].value;
                  if (this.customRangeSelected !== null && alaef_ranges_pure.indexOf(range_to_select) !== -1) {
                    range_to_select = this.customRangeSelected;
                  }
                  if (this.is_debug) console.log('first from range: to_select/selected', range_to_select, this.alaef_range_selected);
                  if (this.alaef_range_selected === range_to_select) {
                    if (this.is_debug) console.log('forced to select', range_to_select);
                    this.selectRange(range_to_select);
                  } else {
                    if (this.is_debug) console.log('trigger to select', range_to_select);
                    this.alaef_range_selected = range_to_select;
                  }
                  // this.selectRange(range_to_select);
                }

                this.counter_max = this.imagesToPreload.length;
                this.btnNextDisabled = false;

              }
            }
          }
        }
      },
      selectRange(v) {
        if (this.is_debug) console.log('selectRange', v);
        if (v !== null) {
          this.current_range = this.current_files_list.find(item => item.step === v);

          if (this.current_range.url.charAt(0) === '/') {
            this.current_range.url = this.current_range.url.substr(1);
          }
          this.current_image = SHMUconf.SITE_DATA_URL + this.current_range.url;
          this.updatePrevNextButtons(v);

          if (!this.isFromMouting) {
            this.customRangeSelected = v;
          }
        }



      },
      setNextRange() {
        let cur_step = this.current_range.step;
        let next_step_idx = null;
        let max_idx = this.alaef_ranges.length;
        let current_index = this.alaef_ranges.findIndex(item => item.value === cur_step);
        if ((current_index+1) < max_idx) {
          next_step_idx = current_index+1;
        }

        if (next_step_idx !== null) {
          this.alaef_range_selected = this.alaef_ranges[next_step_idx].value;
          // this.selectRange(this.alaef_ranges[next_step_idx].value);
        }

      },
      setPrevRange() {
        let cur_step = this.current_range.step;
        let prev_step_idx = null;
        let current_index = this.alaef_ranges.findIndex(item => item.value === cur_step);
        if ((current_index-1) >= 0) {
          prev_step_idx = current_index-1;
        }

        if (prev_step_idx !== null) {
          this.alaef_range_selected = this.alaef_ranges[prev_step_idx].value;
          // this.selectRange(this.alaef_ranges[prev_step_idx].value);
        }

      },
      updatePrevNextButtons(step) {
        let max_idx = this.alaef_ranges.length;
        let current_index = this.alaef_ranges.findIndex(item => item.value === step);
        if (current_index === max_idx-1) {
          this.btnNextDisabled = true;
        } else {
          this.btnNextDisabled = false;
        }

        if (current_index === 0) {
          this.btnPrevDisabled = true;
        } else {
          this.btnPrevDisabled = false;
        }

      },
      resetZoom() {
        if (this.$refs.pz.getScale() > 1) {
          this.showResetZoom = false;
          this.$refs.pz.toggleZoom();
        }
      },
      onHidden() {
        // this.$refs.button.focus()
      },
      imageLoadedOne(e) {
        this.counter_current = e.count;
        this.counter_max = e.length;
      },
      imageLoadedAll(e) {
        this.isImagesLoading = false;
        this.busy = false;
        this.counter_current = 1;
        this.counter_max = 100;
      },
      imagePreloadError(e) {
        const self = this;
        this.isImagesLoading = false;
        this.busy = false;
        this.counter_current = 1;
        this.counter_max = 100;

        this.makeToast(this.$t('nastala_chyba'), this.$t('images_loading_error'), 'danger');
        this.isError = true;
        this.errorMsg = this.$t('images_loading_error');

        console.log('Nepodarilo sa nacitat: ',  e.errorImgs);
      },
      makeToast(title, message, variant = null) {
        this.$bvToast.toast(message, {
          title: title,
          variant: variant,
          solid: true
        })
      },
      switchLang() {
        let lang = 'sk';
        if (i18n.locale === 'sk') lang = 'en';
        i18n.locale = lang;
        /*
        this.$router.push({
          params: {
            lang: lang
          }
        });
         */
      },
      imgMouseMove: _.throttle( function(e) {

        if (!this.showTooltip) return;

        const self = this;


        if (!self.current_product_meta) return;
        if (!self.current_product_meta.colors) return;
        if (self.current_product_meta.colors.length === 0) return;

        let x, y;
        if(e.offsetX) {
          x = e.offsetX;
          y = e.offsetY;
        }
        else if(e.layerX) {
          x = e.layerX;
          y = e.layerY;
        }
        let canvas = this.$refs['cs'];
        let img = this.$refs['imgalaef'];
        let pz = this.$refs['pz'];

        if (this.imgInCanvas !== this.current_image) {
          if (this.is_debug) console.log('new canvas image')
          this.applyImageToCanvas(canvas, img);
          this.imgInCanvas = this.current_image;
          this.canvasData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
        }

        let add_x_offset = Math.round((pz.$el.clientWidth - img.clientWidth)/2);


        let px = Math.round((x*100)/img.clientWidth);
        let py = Math.round((y*100)/img.clientHeight);

        let nove_x = x+add_x_offset;

        // console.log(pz.$el.clientWidth, img.clientWidth, x, nove_x, y);

        self.$refs['ttip'].style.left = (nove_x+5)+'px';
        self.$refs['ttip'].style.top = (y-20)+'px';
        self.$refs['ttip'].style.display = 'block';

        // let p = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
        let index = (y * this.canvasData.width + x) * 4;

        let p = [];
        p.push(this.canvasData.data[index]);
        p.push(this.canvasData.data[index+1]);
        p.push(this.canvasData.data[index+2]);
        p.push(this.canvasData.data[index+3]);

        // show preview color
        if (p) {
          //self.ttipVal = self.rgbToHex(p[0], p[1], p[2]);
          let hex_color = self.rgbToHex(p[0], p[1], p[2]);
          let color_type = 'PRIEMER';
          if (self.current_product_meta.color_type === 'all') color_type = 'ALL';
          else {
            if (px >= 50 && py <= 50) color_type = 'ROZPTYL';
            else color_type = 'PRIEMER';
          }

          //console.log(color_type)

          let skala = self.current_product_meta.colors.filter( item => item.type === color_type);

          let naslo_sa = skala.find(item => this.isNeighborColor(this.hexToRgb(item.hex_color), this.hexToRgb(hex_color), 3));

          if (naslo_sa) {
            // self.$refs['ttip'].innerHTML = naslo_sa.display + ' ' + hex_color;
            self.$refs['ttip'].innerHTML = naslo_sa.display;
            self.$refs['ttip'].style.display = 'block';
          } else {
            // self.$refs['ttip'].style.display = 'block';
            // self.$refs['ttip'].innerHTML = hex_color;
            self.$refs['ttip'].style.display = 'none';
          }


        }

      }, 150),
      imgMouseLeave: _.debounce( function() {
        // console.log('heh')
        this.$refs['ttip'].style.display = 'none';

      },500),
      imgMouseOut(e) {

      },
      applyImageToCanvas(el, image)
      {
        el.width = image.width; // img width
        el.height = image.height; // img height
        // draw image in canvas tag
        el.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
      },
      componentToHex(c) {
        if (c) {
          let hex = c.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        }
        return "00";
      },
      rgbToHex(r, g, b) {
        return this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
      },
      hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      },
      isNeighborColor(color1, color2, tolerance) {
        if (tolerance === undefined) {
          tolerance = 10;
        }

        // console.log(color1, color2);

        return Math.abs(color1.r - color2.r) <= tolerance
          && Math.abs(color1.g - color2.g) <= tolerance
          && Math.abs(color1.b - color2.b) <= tolerance;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-inline {
    .form-control {
      display: inline-block !important;
      width: auto!important
    }
    label {
      display: block!important;
      align-items: center;
      justify-content: center;
      margin-bottom: 0;
    }
    .form-group {
      display: flex;
      flex: 0 0 auto;
      flex-flow: row wrap;
      align-items: center;
      margin-bottom: 0;
    }
    .custom-select {
      width: auto;
    }
  }

  .preview {
    width: 50px;
    height: 50px;
    border: 1px solid #aaa;
  }

  .tooltipx {
    position: absolute;
    background-color: rgba(0,0,0,0.7);
    color: white;
    border: none;
    border-radius: 3px;
    padding: 2px 3px;
    top: -500px;
    left: -500px;
    text-align: center;
    z-index: 100;
    width: 60px;
    height: 23px;
    line-height: 18px;
    font-size:0.8rem;
    display: none;
  }

  .alaef-card {
    font-size:0.9em;

    .custom-select {
      font-size: 1em;
    }

  }

  .wh_flag {
    width: 35px;
    height: 35px;
  }


</style>
